import { Attachment } from "../../create-conversation-body";
import { RuleActionType } from "./types";

export enum SetStatusActionStatus {
  OPEN = "open",
  CLOSED = "closed",
  ARCHIVED = "archived",
  SPAM = "spam",
  SNOOZED = "snoozed",
}

export enum SetStatusSnoozePeriod {
  TODAY = "today",
  TOMORROW = "tomorrow",
  WEEKEND = "weekend",
  NEXT_WEEK = "nextWeek",
}

export interface SetStatusActionConfig {
  actionType: RuleActionType.SET_STATUS;
  status: SetStatusActionStatus;
  snoozePeriod?: SetStatusSnoozePeriod;
}

export interface AddTagActionConfig {
  actionType: RuleActionType.ADD_TAG;
  tag: string[];
}

export interface AutoReplyActionConfig {
  actionType: RuleActionType.AUTO_REPLY;
  textContent: string;
  htmlContent: string;
  attachments?: Attachment[];
}

export interface AssignActionConfig {
  actionType: RuleActionType.ASSIGN;
  user: { id: string; name: string };
}

export type RuleActionConfig =
  | SetStatusActionConfig
  | AddTagActionConfig
  | AutoReplyActionConfig
  | AssignActionConfig;
